<!-- Below ngclass validation used for the UI purpose, not correct validations -->
<tr class="bulkListTable__rowMain" [ngClass]="{'bulkListTable__rowMainred': !bulktableData?.name || bulktableData?.email==='19520102' || !bulktableData?.number || !bulktableData?.roles || bulktableData?.branches==='4 branches' }">
  <td class="bulkListTable__name">
    @if (bulktableData?.name!='') {
      <div>{{bulktableData?.name}}</div>
    }
    <!-- If the data displayed is invalid or empty, we can edit the data (validations are not given)-->
    @if (bulktableData?.name==='') {
      <div class="error-and-input"><img src="../../../../assets/Images/user-management/error.svg" alt="invalid" class="error-image"> <input [ngModel]="bulktableData?.name" type="text" class="form-control" [value]="bulktableData?.name"></div>
    }
  </td>
  <td class="bulkListTable__email">
    @if (bulktableData?.email!='19520102') {
      <div>{{bulktableData?.email}}</div>
    }
    @if (bulktableData?.email==='19520102') {
      <div class="error-and-input"><img src="../../../../assets/Images/user-management/error.svg" alt="invalid" class="error-image"> <input [ngModel]="bulktableData?.email" type="email" class="form-control"></div>
    }
  </td>
  <td class="bulkListTable__mobile-number">
    @if (bulktableData?.number!='') {
      <div>{{bulktableData?.number}}</div>
    }
    @if (bulktableData?.number==='') {
      <div class="error-and-input"><img src="../../../../assets/Images/user-management/error.svg" alt="invalid" class="error-image"> <input [ngModel]="bulktableData?.number" type="text" class="form-control"></div>
    }
  </td>
  <td class="bulkListTable__roles">
    @if (bulktableData?.roles!='') {
      <div>{{bulktableData?.roles}}</div>
    }
    @if (bulktableData?.roles==='') {
      <div class="error-and-input"><img src="../../../../assets/Images/user-management/error.svg" alt="invalid" class="error-image"> <input [ngModel]="bulktableData?.roles" type="text" class="form-control"></div>
    }
  </td>
  <td class="bulkListTable__branches">
    @if (bulktableData?.branches!='4 branches') {
      <div>{{bulktableData?.branches}}</div>
    }
    @if (bulktableData?.branches==='4 branches') {
      <div class="error-and-input"><img src="../../../../assets/Images/user-management/error.svg" alt="invalid" class="error-image"> <input [ngModel]="bulktableData?.branches" type="text" class="form-control"></div>
    }
  </td>
</tr>